import React from 'react'
import PostComponent from './search/PostComponent'
import { IData } from '../blogImg'

interface IProps {
  data: IData[]
}

const NewsItem = (props: IProps) => {
  const { data } = props
  var items = []
  var firstItem = <></>
  var firstArticle: IData
  const classes =
    'grid grid-cols-1 gap-[1.875rem] sm:grid-cols-2 md:grid-cols-3'

  if (data && data.length !== 0) {
    firstArticle = data[0]
  } else {
    return <></>
  }

  if (firstArticle.metadata !== undefined) {
    firstItem = (
      <PostComponent key='first-article' post={firstArticle} isFirst={true} />
    )
  }

  items = data.slice(1).map((item, index) => {
    if (item.metadata !== undefined) {
      return (
        <PostComponent key={`art-id-${index}`} post={item} isFirst={false} />
      )
    }
  })

  return (
    <>
      {firstItem}
      <div className={`rounded-2xl ${classes}`}>
        {items.length > 0 ? items : <></>}
      </div>
    </>
  )
}

export default NewsItem
